import { useEffect, useState } from "react";
import { Button, Col, Row, Container, Form, OverlayTrigger, Tooltip, Spinner } from "react-bootstrap";
import InputMask from "react-input-mask";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

import xVerifyEmailService, { VALID_EMAIL_STATUSES, INVALID_EMAIL_STATUSES, VALIDATION_MESSAGE } from "../services/xVerifyEmailService";
import { checkEmail } from "../helpers/emailChecker";
import { usePrevious } from "../V2/hooks";

import { state_array as STATES } from "../variables/Variables";
import StepProgressOrder from "../component/Status/StepProgressOrder";

const eye = <FontAwesomeIcon icon={faEye} />;

export default function OrderStatusResult(props) {
  const basePath = process.env.NEXT_PUBLIC_BASE_PATH;
  
  const [passwordShown, setPasswordShown] = useState(false);
  const [customerEmail, setCustomerEmail] = useState("");
  const [last4SSN, setLast4SSN] = useState("");
  const [token, setToken] = useState(null);
  const [validated, setValidated] = useState(false);
  const [dError, setdError] = useState(null);
  const [product, setProduct] = useState(null);
  const [llcName, setLLCName] = useState("");
  const [llcName2, setLLCName2] = useState("");
  const [llcName3, setLLCName3] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [suffix, setSuffix] = useState("");
  const [ssn, setSSN] = useState("");
  const [thankyou, setThankyou] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [data, setData] = useState(null);

  const [verifying, setVerifying] = useState(false);
  const [verificationResult, setVerificationResult] = useState(null);
  const [suspendedSubmit, setSuspendedSubmit] = useState(false);

  const prevVerifying =  usePrevious(verifying);

  const togglePasswordVisiblity = () => setPasswordShown(!passwordShown);

  const handleEmailChange = (e) => {
    setVerificationResult(null);
    setCustomerEmail(e.target.value);
  }

  const handleBlur = (e) => {
    const { type, value } = e.target;
    if (type === "email" && value) {
      if (!verificationResult && checkEmail(value)) {
        setVerifying(true);
        let emailValue = value;
        if (emailValue.indexOf("+") > -1 && emailValue.indexOf("gmail.com") > -1) {
          emailValue =
            emailValue.substring(0, emailValue.indexOf("+")) +
            emailValue.substring(emailValue.indexOf("@"), emailValue.length);
        }
        xVerifyEmailService(emailValue)
          .then(result => {
            setVerificationResult(result);
            setVerifying(false);
          });
      }
    }
  };

  const handleKeyDown = (e) => {
    const { type, value } = e.target;
    if (type === "email" && value && e.code === "Enter") {
      if (!verificationResult && checkEmail(value)) {
        setVerifying(true);
        setSuspendedSubmit(true);

        let emailValue = value;
        if (emailValue.indexOf("+") > -1 && emailValue.indexOf("gmail.com") > -1) {
          emailValue =
            emailValue.substring(0, emailValue.indexOf("+")) +
            emailValue.substring(emailValue.indexOf("@"), emailValue.length);
        }
        xVerifyEmailService(emailValue)
          .then(result => {
            setVerificationResult(result);
            setVerifying(false);
          });
      }
    }
  };

  const handleSubmit = (e) => {
    setdError(null);
    e.preventDefault();

    if (verifying) {
      return;
    }

    setSuspendedSubmit(false);

    const form = e.currentTarget;

    const section1 = document.querySelector(".is-invalid");
    if (section1 != null) {
      section1.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      if (form.checkValidity() === false) {
        e.preventDefault();
        e.stopPropagation();
        const section = document.querySelector(".form-control:invalid");
        if (section != null) section.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        axios
          .get(process.env.NEXT_PUBLIC_REACT_APP_API + "/orders/" + props.order.orderUid + "/PDF", {
            params: {
              email: customerEmail,
              last4: last4SSN,
            },
            responseType: "arraybuffer",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/pdf",
            },
          })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            const file_name = props.state.orderNumber + ".pdf";
            link.setAttribute("download", file_name);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          })
          .catch((error) => {
            if(error.response)
              setdError(error.response.statusText);
          });
      }
    }
    setValidated(true);
  };

  const handleSubmitTokenRequest = (e) => {
    setdError(null);
    e.preventDefault();

    if (verifying) {
      return;
    }

    setSuspendedSubmit(false);

    const form = e.currentTarget;

    const section1 = document.querySelector(".is-invalid");
    if (section1 != null) {
      section1.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      if (form.checkValidity() === false) {
        e.preventDefault();
        e.stopPropagation();
        const section = document.querySelector(".form-control:invalid");
        if (section != null) section.scrollIntoView({ behavior: "smooth", block: "start" });
        setValidated(true);
      } else {
        setValidated(true);
        const orderIdentify = props.order.orderUid ? props.order.orderUid : props.state.orderNumber;
        axios
          .post(
            process.env.NEXT_PUBLIC_REACT_APP_API + "/orders/" + orderIdentify + "/token",
            {},
            {
              params: {
                email: customerEmail,
              },
              headers: { Accept: "application/json" },
            }
          )
          .then((response) => {
            setToken(response.data.token);
            setValidated(false);
            axios
              .get(process.env.NEXT_PUBLIC_REACT_APP_API + "/orders/" + props.order.orderUid, {
                headers: {
                  Authorization: "Bearer " + response.data.token,
                },
              })
              .then((response) => {
                setData(response.data);
                if (response.data.products && response.data.products.length >= 1) {
                  let lastProduct = response.data.products.length - 1;
                  if (response.data.order.productCode) {
                    if (
                      response.data.order.productCode.code === "EIN_LLC" ||
                      response.data.order.productCode.code === "EIN_SoleProp"
                    ) {
                      setLastName(response.data.products[lastProduct].owner.lastName);
                      setFirstName(response.data.products[lastProduct].owner.firstName);
                      setMiddleName(response.data.products[lastProduct].owner.middleName);
                      setSuffix(response.data.products[lastProduct].owner.suffixName);
                      setSSN(response.data.products[lastProduct].owner.ssn);
                    } else if (
                      response.data.order.productCode.code === "EIN_CCorp" ||
                      response.data.order.productCode.code === "EIN_PSC" ||
                      response.data.order.productCode.code === "EIN_SCorp"
                    ) {
                      setLastName(response.data.products[lastProduct].principalOfficer.lastName);
                      setFirstName(response.data.products[lastProduct].principalOfficer.firstName);
                      setMiddleName(response.data.products[lastProduct].principalOfficer.middleName);
                      setSuffix(response.data.products[lastProduct].principalOfficer.suffixName);
                      setSSN(response.data.products[lastProduct].principalOfficer.ssn);
                    } else if (
                      response.data.order.productCode.code === "EIN_Church" ||
                      response.data.order.productCode.code === "EIN_NonProfit"
                    ) {
                      setLastName(response.data.products[lastProduct].responsibleParty.lastName);
                      setFirstName(response.data.products[lastProduct].responsibleParty.firstName);
                      setMiddleName(response.data.products[lastProduct].responsibleParty.middleName);
                      setSuffix(response.data.products[lastProduct].responsibleParty.suffixName);
                      setSSN(response.data.products[lastProduct].responsibleParty.ssn);
                    } else if (response.data.order.productCode.code === "EIN_Estate") {
                      setLastName(response.data.products[lastProduct].representative.lastName);
                      setFirstName(response.data.products[lastProduct].representative.firstName);
                      setMiddleName(response.data.products[lastProduct].representative.middleName);
                      setSuffix(response.data.products[lastProduct].representative.suffixName);
                      setSSN(response.data.products[lastProduct].representative.ssn);
                    } else if (response.data.order.productCode.code === "EIN_Partnership") {
                      setLastName(response.data.products[lastProduct].primaryPartner.lastName);
                      setFirstName(response.data.products[lastProduct].primaryPartner.firstName);
                      setMiddleName(response.data.products[lastProduct].primaryPartner.middleName);
                      setSuffix(response.data.products[lastProduct].primaryPartner.suffixName);
                      setSSN(response.data.products[lastProduct].primaryPartner.ssn);
                    } else if (response.data.order.productCode.code === "EIN_Trust") {
                      setLastName(response.data.products[lastProduct].trustee.lastName);
                      setFirstName(response.data.products[lastProduct].trustee.firstName);
                      setMiddleName(response.data.products[lastProduct].trustee.middleName);
                      setSuffix(response.data.products[lastProduct].trustee.suffixName);
                      setSSN(response.data.products[lastProduct].trustee.ssn);
                    }
                  } else {
                    let productCodes = response.data.order.productCodes.length - 1;
                    if (
                      response.data.order.productCodes[productCodes].code === "EIN_LLC" ||
                      response.data.order.productCodes[productCodes].code === "EIN_SoleProp"
                    ) {
                      setLastName(response.data.products[lastProduct].owner.lastName);
                      setFirstName(response.data.products[lastProduct].owner.firstName);
                      setMiddleName(response.data.products[lastProduct].owner.middleName);
                      setSuffix(response.data.products[lastProduct].owner.suffixName);
                      setSSN(response.data.products[lastProduct].owner.ssn);
                    } else if (
                      response.data.order.productCodes[productCodes].code === "EIN_CCorp" ||
                      response.data.order.productCodes[productCodes].code === "EIN_PSC" ||
                      response.data.order.productCodes[productCodes].code === "EIN_SCorp"
                    ) {
                      setLastName(response.data.products[lastProduct].principalOfficer.lastName);
                      setFirstName(response.data.products[lastProduct].principalOfficer.firstName);
                      setMiddleName(response.data.products[lastProduct].principalOfficer.middleName);
                      setSuffix(response.data.products[lastProduct].principalOfficer.suffixName);
                      setSSN(response.data.products[lastProduct].principalOfficer.ssn);
                    } else if (
                      response.data.order.productCodes[productCodes].code === "EIN_Church" ||
                      response.data.order.productCodes[productCodes].code === "EIN_NonProfit"
                    ) {
                      setLastName(response.data.products[lastProduct].responsibleParty.lastName);
                      setFirstName(response.data.products[lastProduct].responsibleParty.firstName);
                      setMiddleName(response.data.products[lastProduct].responsibleParty.middleName);
                      setSuffix(response.data.products[lastProduct].responsibleParty.suffixName);
                      setSSN(response.data.products[lastProduct].responsibleParty.ssn);
                    } else if (response.data.order.productCodes[productCodes].code === "EIN_Estate") {
                      setLastName(response.data.products[lastProduct].representative.lastName);
                      setFirstName(response.data.products[lastProduct].representative.firstName);
                      setMiddleName(response.data.products[lastProduct].representative.middleName);
                      setSuffix(response.data.products[lastProduct].representative.suffixName);
                      setSSN(response.data.products[lastProduct].representative.ssn);
                    } else if (response.data.order.productCodes[productCodes].code === "EIN_Partnership") {
                      setLastName(response.data.products[lastProduct].primaryPartner.lastName);
                      setFirstName(response.data.products[lastProduct].primaryPartner.firstName);
                      setMiddleName(response.data.products[lastProduct].primaryPartner.middleName);
                      setSuffix(response.data.products[lastProduct].primaryPartner.suffixName);
                      setSSN(response.data.products[lastProduct].primaryPartner.ssn);
                    } else if (response.data.order.productCodes[productCodes].code === "EIN_Trust") {
                      setLastName(response.data.products[lastProduct].trustee.lastName);
                      setFirstName(response.data.products[lastProduct].trustee.firstName);
                      setMiddleName(response.data.products[lastProduct].trustee.middleName);
                      setSuffix(response.data.products[lastProduct].trustee.suffixName);
                      setSSN(response.data.products[lastProduct].trustee.ssn);
                    }
                  }
                  setProduct(response.data.products[lastProduct]);
                }
              })
              .catch((error) => {
                console.log(error);
                setdError(error.response.statusText);
              });
          })
          .catch((error) => {
            setdError(error.response.statusText);
          });
      }
    }
  };
  const handleSubmitLLC = (e) => {
    setdError(null);
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      const section = document.querySelector(".form-control:invalid");
      if (section != null) section.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      if (data.products && data.products.length >= 1) {
        let lastProduct = data.products.length - 1;
        data.products[lastProduct].legalName = llcName;
        if (llcName2 !== "" || llcName3 !== "") {
          data.products[lastProduct].alternateLegalNames = [];
          if (llcName2 !== "") data.products[lastProduct].alternateLegalNames.push(llcName2);
          if (llcName3 !== "") data.products[lastProduct].alternateLegalNames.push(llcName3);
        } else {
          if (data.products[lastProduct].alternateLegalNames) {
            delete data.products[lastProduct].alternateLegalNames;
          }
        }
      }
      axios
        .put(process.env.NEXT_PUBLIC_REACT_APP_API + "/orders/" + props.order.orderUid, data, {
          crossdomain: true,
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Cache-Control": "no-cache",
            Authorization: "Bearer " + token,
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (selectedFile) {
              const formData = new FormData();
              formData.append("file", selectedFile);
              axios
                .post(
                  process.env.NEXT_PUBLIC_REACT_APP_API +
                    "/orders/" +
                    props.order.orderUid +
                    "/file?fileType=articles_of_incorporation",
                  formData,
                  {
                    crossdomain: true,
                    headers: {
                      "Content-Type": "multipart/form-data",
                      "Cache-Control": "no-cache",
                      Authorization: "Bearer " + token,
                      "Access-Control-Allow-Origin": "*",
                    },
                  }
                )
                .then((response) => {
                  if (response.status === 200) {
                    setThankyou(true);
                  }
                })
                .catch((error) => {
                  setdError(error.message);
                });
            } else setThankyou(true);
          }
        })
        .catch((error) => {
          console.log(error);
          setdError(error.message);
        });
    }
    setValidated(true);
  };
  const handleSubmitMismatch = (e) => {
    setdError(null);
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      const section = document.querySelector(".form-control:invalid");
      if (section != null) section.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      if (data.products && data.products.length >= 1) {
        let lastProduct = data.products.length - 1;
        if (data.order.productCode) {
          if (data.order.productCode.code === "EIN_LLC" || data.order.productCode.code === "EIN_SoleProp") {
            data.products[lastProduct].owner.lastName = lastName;
            data.products[lastProduct].owner.firstName = firstName;
            data.products[lastProduct].owner.middleName = middleName;
            data.products[lastProduct].owner.suffixName = suffix;
            data.products[lastProduct].owner.ssn = ssn;
          } else if (
            data.order.productCode.code === "EIN_CCorp" ||
            data.order.productCode.code === "EIN_PSC" ||
            data.order.productCode.code === "EIN_SCorp"
          ) {
            data.products[lastProduct].principalOfficer.lastName = lastName;
            data.products[lastProduct].principalOfficer.firstName = firstName;
            data.products[lastProduct].principalOfficer.middleName = middleName;
            data.products[lastProduct].principalOfficer.suffixName = suffix;
            data.products[lastProduct].principalOfficer.ssn = ssn;
          } else if (data.order.productCode.code === "EIN_Church" || data.order.productCode.code === "EIN_NonProfit") {
            data.products[lastProduct].responsibleParty.lastName = lastName;
            data.products[lastProduct].responsibleParty.firstName = firstName;
            data.products[lastProduct].responsibleParty.middleName = middleName;
            data.products[lastProduct].responsibleParty.suffixName = suffix;
            data.products[lastProduct].responsibleParty.ssn = ssn;
          } else if (data.order.productCode.code === "EIN_Estate") {
            data.products[lastProduct].representative.lastName = lastName;
            data.products[lastProduct].representative.firstName = firstName;
            data.products[lastProduct].representative.middleName = middleName;
            data.products[lastProduct].representative.suffixName = suffix;
            data.products[lastProduct].representative.ssn = ssn;
          } else if (data.order.productCode.code === "EIN_Partnership") {
            data.products[lastProduct].primaryPartner.lastName = lastName;
            data.products[lastProduct].primaryPartner.firstName = firstName;
            data.products[lastProduct].primaryPartner.middleName = middleName;
            data.products[lastProduct].primaryPartner.suffixName = suffix;
            data.products[lastProduct].primaryPartner.ssn = ssn;
          } else if (data.order.productCode.code === "EIN_Trust") {
            data.products[lastProduct].trustee.lastName = lastName;
            data.products[lastProduct].trustee.firstName = firstName;
            data.products[lastProduct].trustee.middleName = middleName;
            data.products[lastProduct].trustee.suffixName = suffix;
            data.products[lastProduct].trustee.ssn = ssn;
          }
        } else {
          let productCodes = data.order.productCodes.length - 1;
          if (
            data.order.productCodes[productCodes].code === "EIN_LLC" ||
            data.order.productCodes[productCodes].code === "EIN_SoleProp"
          ) {
            data.products[lastProduct].owner.lastName = lastName;
            data.products[lastProduct].owner.firstName = firstName;
            data.products[lastProduct].owner.middleName = middleName;
            data.products[lastProduct].owner.suffixName = suffix;
            data.products[lastProduct].owner.ssn = ssn;
          } else if (
            data.order.productCodes[productCodes].code === "EIN_CCorp" ||
            data.order.productCodes[productCodes].code === "EIN_PSC" ||
            data.order.productCodes[productCodes].code === "EIN_SCorp"
          ) {
            data.products[lastProduct].principalOfficer.lastName = lastName;
            data.products[lastProduct].principalOfficer.firstName = firstName;
            data.products[lastProduct].principalOfficer.middleName = middleName;
            data.products[lastProduct].principalOfficer.suffixName = suffix;
            data.products[lastProduct].principalOfficer.ssn = ssn;
          } else if (
            data.order.productCodes[productCodes].code === "EIN_Church" ||
            data.order.productCodes[productCodes].code === "EIN_NonProfit"
          ) {
            data.products[lastProduct].responsibleParty.lastName = lastName;
            data.products[lastProduct].responsibleParty.firstName = firstName;
            data.products[lastProduct].responsibleParty.middleName = middleName;
            data.products[lastProduct].responsibleParty.suffixName = suffix;
            data.products[lastProduct].responsibleParty.ssn = ssn;
          } else if (data.order.productCodes[productCodes].code === "EIN_Estate") {
            data.products[lastProduct].representative.lastName = lastName;
            data.products[lastProduct].representative.firstName = firstName;
            data.products[lastProduct].representative.middleName = middleName;
            data.products[lastProduct].representative.suffixName = suffix;
            data.products[lastProduct].representative.ssn = ssn;
          } else if (data.order.productCodes[productCodes].code === "EIN_Partnership") {
            data.products[lastProduct].primaryPartner.lastName = lastName;
            data.products[lastProduct].primaryPartner.firstName = firstName;
            data.products[lastProduct].primaryPartner.middleName = middleName;
            data.products[lastProduct].primaryPartner.suffixName = suffix;
            data.products[lastProduct].primaryPartner.ssn = ssn;
          } else if (data.order.productCodes[productCodes].code === "EIN_Trust") {
            data.products[lastProduct].trustee.lastName = lastName;
            data.products[lastProduct].trustee.firstName = firstName;
            data.products[lastProduct].trustee.middleName = middleName;
            data.products[lastProduct].trustee.suffixName = suffix;
            data.products[lastProduct].trustee.ssn = ssn;
          }
        }
      }
      axios
        .put(process.env.NEXT_PUBLIC_REACT_APP_API + "/orders/" + props.order.orderUid, data, {
          crossdomain: true,
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Cache-Control": "no-cache",
            Authorization: "Bearer " + token,
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          if (response.status === 200) {
            setThankyou(true);
          }
        })
        .catch((error) => {
          setdError(error.message);
        });
    }
    setValidated(true);
  };

  useEffect(() => {
    if (prevVerifying && !verifying && suspendedSubmit) {
      document.getElementById("OrderStatusSubmitButton1")?.click();
      document.getElementById("OrderStatusSubmitButton2")?.click();
      document.getElementById("OrderStatusSubmitButton3")?.click();
    }
  }, [verifying, prevVerifying, suspendedSubmit]);

  const isEmailValid = verificationResult?.status && !verifying ? VALID_EMAIL_STATUSES.includes(verificationResult.status) : undefined;
  const isEmailInvalid = verificationResult?.status && !verifying ? INVALID_EMAIL_STATUSES.includes(verificationResult.status) : undefined;
  const invalidEmailMessage = VALIDATION_MESSAGE[verificationResult?.reason] || "You must provide a valid email address";

  let oneDay = new Date();
  let now = new Date();
  oneDay.setDate(now.getDate() + 1);
  if (thankyou) {
    return (
      <div className="thank-you">
        <StepProgressOrder step={0} status={props.order.processingStatus} />
        <img alt="" src={`${basePath}/images/thank-you.png`} style={{ marginTop: "50px" }} />
        <Col sm={12}>
          <h2>Thank you</h2>
          <h3>Your Order is updated</h3>
        </Col>
      </div>
    );
  }
  return (
    <div className="home ">
      <div className="content">
        <h3>
          Order Status{" "}
          {props.order.productCodes.length === 1
            ? props.order.productCodes[0].customerName
            : props.order.productCodes[1].customerName}
        </h3>
        <hr />
        <StepProgressOrder step={0} status={props.order.processingStatus} />
        {props.order.processingStatus === "Completed" ? (
          <>
            <Container fluid className="Form contact">
              {props.order.productCodes.length === 2 ? (
                <Form noValidate id="kform">
                  <Form.Group controlId="header">
                    <Form.Label className="mb-5">
                      Your LLC Inc. was generated and sent to the e-mail address on file.
                    </Form.Label>
                  </Form.Group>
                </Form>
              ) : (
                <Form noValidate validated={validated} onSubmit={handleSubmit} id="kform">
                  <Form.Group controlId="header">
                    <Form.Label className="mb-5">
                      Your EIN/Tax ID was generated and sent to the e-mail address on file. To download a copy here,
                      please enter your e-mail address and last 4 digits of the Responsible Party&apos;s Social Security
                      Number below.
                    </Form.Label>
                  </Form.Group>
                  <Form.Group controlId="orderNumber">
                    <Form.Label>Order number</Form.Label>
                    <Form.Control type="text" defaultValue={props.state.orderNumber} readOnly />
                  </Form.Group>
                  <Form.Group controlId="customerEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                      type="email"
                      required
                      placeholder="Enter email"
                      pattern="^([a-zA-Z0-9_\-\+\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
                      defaultValue={customerEmail}
                      isValid={isEmailValid}
                      isInvalid={isEmailInvalid}
                      onChange={handleEmailChange}
                      onBlur={handleBlur}
                      onKeyDown={handleKeyDown}
                      onMouseDown={() => setSuspendedSubmit(true)}
                    />
                    {verifying && (
                      <Form.Control.Feedback type="processing">
                        Verification...
                      </Form.Control.Feedback>
                    )}
                    <Form.Control.Feedback type="invalid">
                      {invalidEmailMessage}
                    </Form.Control.Feedback>
                    {verifying && (
                      <Spinner
                        animation="border"
                        variant="secondary"
                        className="form-control-loader"
                      />
                    )}
                  </Form.Group>
                  <Form.Group controlId="last4SSN">
                    <Form.Label>Last 4 of SSN</Form.Label>
                    <InputMask
                      mask="9999"
                      defaultValue={last4SSN}
                      onChange={(e) => setLast4SSN(e.target.value)}
                      maskChar={null}
                    >
                      {(inputProps) => <Form.Control required type="text" placeholder="XXXX" pattern=".{4,}" />}
                    </InputMask>
                    <Form.Control.Feedback type="invalid">
                      Please specify last 4 digits of the Responsible Party&apos;s Social Security Number
                    </Form.Control.Feedback>
                  </Form.Group>
                  <div className="invalid-feedback d-block mt-0 mb-2">{dError}</div>
                  <Button variant="primary" type="submit" className="mt-4" id="OrderStatusSubmitButton1">
                    Download
                  </Button>
                </Form>
              )}
            </Container>
          </>
        ) : null}
        {props.order.processingStatus === "Completed_SS4" ? (
          <>
            <Container fluid className="Form contact">
              <Form>
                <Form.Group controlId="header">
                  <Form.Label className="mb-5">
                    Your order has been completed. We have received your signed SS-4 form and have submitted it directly
                    to the IRS. You can expect to receive your EIN from the IRS by mail shortly.
                  </Form.Label>
                </Form.Group>
              </Form>
            </Container>
          </>
        ) : null}
        {props.order.processingStatus === "RAaddressAdded" ? (
          <>
            <Container fluid className="Form contact">
              <Form>
                <Form.Group controlId="header">
                  <Form.Label className="mb-5">
                    Your Resident Agent has been assigned. Your Address to use for official communications with the State is:
                  </Form.Label>
                  {props.order.productResult && (
                    <>
                      <Row>
                        <Col xs={0} md={2} />
                        <Col xs={6} md={4}>
                          <Form.Label className="mb-2">
                            <strong>
                              Address:
                            </strong>
                          </Form.Label>
                        </Col>
                        <Col xs={6} md={4}>
                          <Form.Label className="mb-2">
                            <span>
                              {props.order.productResult?.address1}
                            </span>
                          </Form.Label>
                        </Col>
                        <Col xs={0} md={2} />
                      </Row>
                      <Row>
                        <Col xs={0} md={2} />
                        <Col xs={6} md={4}>
                          <Form.Label className="mb-2">
                            <strong>
                              City:
                            </strong>
                          </Form.Label>
                        </Col>
                        <Col xs={6} md={4}>
                          <Form.Label className="mb-2">
                            <span>
                              {props.order.productResult?.city}
                            </span>
                          </Form.Label>
                        </Col>
                        <Col xs={0} md={2} />
                      </Row>
                      <Row>
                        <Col xs={0} md={2} />
                        <Col xs={6} md={4}>
                          <Form.Label className="mb-2">
                            <strong>
                              State / Province:
                            </strong>
                          </Form.Label>
                        </Col>
                        <Col xs={6} md={4}>
                          <Form.Label className="mb-2">
                            <span>
                              {STATES[props.order.productResult?.state]}
                            </span>
                          </Form.Label>
                        </Col>
                        <Col xs={0} md={2} />
                      </Row>
                      <Row>
                        <Col xs={0} md={2} />
                        <Col xs={6} md={4}>
                          <Form.Label className="mb-2">
                            <strong>
                              ZIP / Postal Code:
                            </strong>
                          </Form.Label>
                        </Col>
                        <Col xs={6} md={4}>
                          <Form.Label className="mb-2">
                            <span>
                              {props.order.productResult?.zip}
                            </span>
                          </Form.Label>
                        </Col>
                        <Col xs={0} md={2} />
                      </Row>
                    </>
                  )}
                </Form.Group>
              </Form>
            </Container>
          </>
        ) : null}
        {props.order.processingStatus === "Rejected" &&
          <>
            <Container fluid className="Form contact">
              <Form>
                <Form.Group controlId="header">
                  <Form.Label className="mb-5">
                    Your order was rejected due to the Secretary of State needing an alternative name, you may still refile with the updated name.
                  </Form.Label>
                </Form.Group>
              </Form>
            </Container>
          </>
        }
        {props.order.processingStatus === "Abandoned" &&
          <>
            <Container fluid className="Form contact">
              <Form>
                <Form.Group controlId="header">
                  <Form.Label className="mb-5">
                    Your filing has been abandoned. For questions please contact customer service.
                  </Form.Label>
                </Form.Group>
              </Form>
            </Container>
          </>
        }
        {props.order.processingStatus === "Cancelled" ? (
          <>
            <Container fluid className="Form contact">
              <Form>
                <Form.Group controlId="header">
                  <Form.Label className="mb-5">
                    Your order was cancelled at your request. A full refund was processed to the card on file. Please
                    allow 3-5 business days for that refund to appear on your account.
                  </Form.Label>
                </Form.Group>
              </Form>
            </Container>
          </>
        ) : null}
        {props.order.processingStatus === "Processing" ? (
          <>
            <Container fluid className="Form contact">
              <Form>
                <Form.Group controlId="header">
                  <Form.Label className="mb-5">
                    Your submission is being reviewed by our Specialists and should be completed shortly. You will
                    receive an e-mail with your official EIN/Tax ID documentation when complete.
                    <br />
                    Estimated Completion Time:&nbsp;
                    {props.order.processingOption === "STANDARD" ? (
                      <>
                        (
                        {oneDay.toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}{" "}
                        12:00 PM EST)
                      </>
                    ) : null}
                    {props.order.processingOption === "RUSH" ? (
                      <>
                        (
                        {now.toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}{" "}
                        8:00 PM EST)
                      </>
                    ) : null}
                  </Form.Label>
                </Form.Group>
              </Form>
            </Container>
          </>
        ) : null}
        {props.order.processingStatus === "Error" &&
        !product &&
        props.order.processingError !== "Error101NameConflict" &&
        (props.order.processingError !== "MismatchError" ||
          (props.order.processingError === "MismatchError" && props.order.productCodes.length === 2)) &&
        props.order.processingError !== "SS4" ? (
          <>
            <Container fluid className="Form contact">
              <Form>
                <Form.Group controlId="header">
                  <Form.Label className="mb-5" style={{ textAlign: "justify" }}>
                    Our specialists have identified an issue with your submission that prevents us from completing the
                    order without additional verification. Please reference the verification section below, or check
                    your e-mail for a follow-up request from us. Please note this is Urgent and we will not be able to
                    proceed until we hear from you.
                    <br />
                    <br />
                    Additional details are required for your submission. You will be contacted by e-mail to provide
                    these details. Please keep a close watch for this e-mail.
                  </Form.Label>
                </Form.Group>
              </Form>
            </Container>
          </>
        ) : null}
        {(props.order.processingStatus === "Error" && !product && props.order.processingError === "SS4") ||
        props.order.processingStatus === "AttemptedNeedsInfo" ? (
          <>
            <Container fluid className="Form contact">
              <Form>
                <Form.Group controlId="header">
                  <Form.Label className="mb-5" style={{ textAlign: "justify" }}>
                    Our specialists have identified an issue with your submission that prevents us from completing the
                    order without additional verification. Please reference the verification section below, or check
                    your e-mail for a follow-up request from us. Please note this is Urgent and we will not be able to
                    proceed until we hear from you.
                    <br />
                    <br />
                    Your submission requires additional documentation which we will submit to the IRS for you. You will
                    receive a Docusign in your e-mail to authorize this submission. Please keep a close watch for this
                    e-mail.
                  </Form.Label>
                </Form.Group>
              </Form>
            </Container>
          </>
        ) : null}
        {props.order.processingStatus === "Error" &&
        !product &&
        props.order.processingError === "Error101NameConflict" ? (
          <>
            <Container fluid className="Form contact">
              <Form noValidate validated={validated} onSubmit={handleSubmitTokenRequest} id="kform">
                <Form.Group controlId="header">
                  <Form.Label className="mb-5" style={{ textAlign: "justify" }}>
                    Our specialists have identified an issue with your submission that prevents us from completing the
                    order without additional verification. Please reference the verification section below, or check
                    your e-mail for a follow-up request from us. Please note this is Urgent and we will not be able to
                    proceed until we hear from you.
                  </Form.Label>
                </Form.Group>
                <Form.Group controlId="orderNumber">
                  <Form.Label>Order number</Form.Label>
                  <Form.Control type="text" defaultValue={props.state.orderNumber} readOnly />
                </Form.Group>
                <Form.Group controlId="customerEmail">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    required
                    placeholder="Enter email"
                    pattern="^([a-zA-Z0-9_\-\+\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
                    defaultValue={customerEmail}
                    isValid={isEmailValid}
                    isInvalid={isEmailInvalid}
                    onChange={handleEmailChange}
                    onBlur={handleBlur}
                    onKeyDown={handleKeyDown}
                    onMouseDown={() => setSuspendedSubmit(true)}
                  />
                  {verifying && (
                    <Form.Control.Feedback type="processing">
                      Verification...
                    </Form.Control.Feedback>
                  )}
                  <Form.Control.Feedback type="invalid">
                    {invalidEmailMessage}
                  </Form.Control.Feedback>
                  {verifying && (
                    <Spinner
                      animation="border"
                      variant="secondary"
                      className="form-control-loader"
                    />
                  )}
                </Form.Group>
                <div className="invalid-feedback d-block mt-0 mb-2">{dError}</div>
                <Button variant="primary" type="submit" className="mt-4" id="OrderStatusSubmitButton2">
                  Submit
                </Button>
              </Form>
            </Container>
          </>
        ) : null}
        {props.order.processingStatus === "Error" &&
        !product &&
        props.order.processingError === "MismatchError" &&
        props.order.productCodes.length === 1 ? (
          <>
            <Container fluid className="Form contact">
              <Form noValidate validated={validated} onSubmit={handleSubmitTokenRequest} id="kform">
                <Form.Group controlId="header">
                  <Form.Label className="mb-5" style={{ textAlign: "justify" }}>
                    Our specialists have identified an issue with your submission that prevents us from completing the
                    order without additional verification. Please reference the verification section below, or check
                    your e-mail for a follow-up request from us. Please note this is Urgent and we will not be able to
                    proceed until we hear from you.
                  </Form.Label>
                </Form.Group>
                <Form.Group controlId="orderNumber">
                  <Form.Label>Order number</Form.Label>
                  <Form.Control type="text" defaultValue={props.state.orderNumber} readOnly />
                </Form.Group>
                <Form.Group controlId="customerEmail">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    required
                    placeholder="Enter email"
                    pattern="^([a-zA-Z0-9_\-\+\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
                    defaultValue={customerEmail}
                    isValid={isEmailValid}
                    isInvalid={isEmailInvalid}
                    onChange={handleEmailChange}
                    onBlur={handleBlur}
                    onKeyDown={handleKeyDown}
                    onMouseDown={() => setSuspendedSubmit(true)}
                  />
                  {verifying && (
                    <Form.Control.Feedback type="processing">
                      Verification...
                    </Form.Control.Feedback>
                  )}
                  <Form.Control.Feedback type="invalid">
                    {invalidEmailMessage}
                  </Form.Control.Feedback>
                  {verifying && (
                    <Spinner
                      animation="border"
                      variant="secondary"
                      className="form-control-loader"
                    />
                  )}
                </Form.Group>
                <div className="invalid-feedback d-block mt-0 mb-2">{dError}</div>
                <Button variant="primary" type="submit" className="mt-4" id="OrderStatusSubmitButton3">
                  Submit
                </Button>
              </Form>
            </Container>
          </>
        ) : null}
        {props.order.processingStatus === "Error" &&
        product &&
        props.order.processingError === "MismatchError" &&
        props.order.productCodes.length === 1 ? (
          <>
            <Container fluid className="Form contact">
              <Form noValidate validated={validated} id="kform" onSubmit={handleSubmitMismatch}>
                <Form.Group controlId="header">
                  <Form.Label className="mb-5" style={{ textAlign: "justify" }}>
                    We have encountered an issue verifying the Responsible Party’s identifying information. In your
                    submission you provided:
                  </Form.Label>
                </Form.Group>
                <Form.Group controlId={"FirstName"}>
                  <Form.Label>First name</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    placeholder="First name"
                    pattern="^[ a-zA-Z&\\-]+$"
                    onKeyPress={(event) => {
                      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
                    }}
                    defaultValue={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                  <Form.Control.Feedback type="invalid">Please provide a valid name</Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId={"MiddleName"}>
                  <Form.Label>Middle name (optional)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Middle name"
                    pattern="^[ a-zA-Z&\\-]+$"
                    onKeyPress={(event) => {
                      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
                    }}
                    onChange={(e) => setMiddleName(e.target.value)}
                    defaultValue={middleName}
                  />
                </Form.Group>
                <Form.Group required controlId={"LastName"}>
                  <Form.Label>Last name</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    placeholder="Last name"
                    pattern="^[ a-zA-Z&\\-]+$"
                    onChange={(e) => setLastName(e.target.value)}
                    defaultValue={lastName}
                    onKeyPress={(event) => {
                      if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
                    }}
                  />
                  <Form.Control.Feedback type="invalid">Please provide last name</Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="responsiblePartySuffixName">
                  <Form.Label>Suffix Name (optional)</Form.Label>
                  <Form.Control as="select" defaultValue={suffix} onChange={(e) => setSuffix(e.target.value)}>
                    <option value="">Please Select</option>
                    <option value="DDS">DDS</option>
                    <option value="MD">MD</option>
                    <option value="PhD">PhD</option>
                    <option value="JR">JR</option>
                    <option value="SR">SR</option>
                    <option value="I">I</option>
                    <option value="II">II</option>
                    <option value="III">III</option>
                    <option value="IV">IV</option>
                    <option value="V">V</option>
                    <option value="VI">VI</option>
                  </Form.Control>
                </Form.Group>
                <Form.Group controlId={"SSN"}>
                  <Form.Label>
                    Social Security Number{" "}
                    <OverlayTrigger
                      placement="right"
                      delay={{ show: 250, hide: 400 }}
                      overlay={
                        <Tooltip id="overlay-example">
                          <strong>Why do we need this?</strong>
                          <br />
                          Your valid Social Security Number is needed by the IRS to obtain an EIN. Rest assured, all
                          Social Security Numbers are stored in a fully protected fashion.
                        </Tooltip>
                      }
                    >
                      <span className="question" />
                    </OverlayTrigger>
                  </Form.Label>
                  <InputMask
                    mask="999-99-9999"
                    onChange={(e) => setSSN(e.target.value)}
                    defaultValue={ssn}
                    maskChar={null}
                  >
                    {(inputProps) => (
                      <Form.Control
                        required
                        type={passwordShown ? "text" : "password"}
                        defaultValue={ssn}
                        placeholder="123-45-6789"
                        pattern=".{11,}"
                      />
                    )}
                  </InputMask>
                  <i onClick={togglePasswordVisiblity}>{eye}</i>{" "}
                  <Form.Control.Feedback type="invalid">
                    Please provide a valid Social Security Number Ex: 123-45-6789
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="header">
                  <Form.Label className="mb-5" style={{ textAlign: "justify" }}>
                    Our validation has shown that the provided Name does not match the Social Security Number provided.
                    Please correct the errors in these fields and hit Submit Updated Info. Please note, this must
                    correspond to the Name and Social Security Number on file with the Social Security Administration
                    and IRS. If you recently changed your name due to marriage, separation, or other life event, please
                    only submit the official name on file.
                  </Form.Label>
                </Form.Group>
                <Button variant="primary" type="submit" className="mt-4">
                  Update info
                </Button>
              </Form>
            </Container>
          </>
        ) : null}
        {props.order.processingStatus === "Error" &&
        product &&
        props.order.processingError === "Error101NameConflict" &&
        product.code.code === "EIN_LLC" ? (
          <>
            <Container fluid className="Form contact">
              <Form noValidate validated={validated} id="kform" onSubmit={handleSubmitLLC}>
                <Form.Group controlId="header">
                  <Form.Label className="mb-5" style={{ textAlign: "justify" }}>
                    We have encountered an issue with the LLC name provided in your submission. This could mean that
                    another LLC in another state has a similar name. Please verify that the name provided below is
                    accurate, and was the name submitted to the state in which you registered the LLC.
                    <br />
                    If you need to make a correction, edit the name below. If the name is correct, we ask that you
                    please provide two alternate names, which could be very slight variations of the provided LLC name.
                  </Form.Label>
                </Form.Group>
                <Form.Group controlId="llcName">
                  <Form.Label>LLC Name</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    placeholder="Name"
                    pattern="(?!.*(?:[ ][cC][oO][rR][pP]$))(?!.*(?:[ ][iI][nN][cC]$))^[ a-zA-Z0-9\\&-]+$"
                    maxLength="70"
                    onChange={(e) => setLLCName(e.target.value)}
                    defaultValue={product.legalName}
                  />
                  <Form.Control.Feedback type="invalid">Please provide a valid organization name</Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="llcName2">
                  <Form.Label>Alternate LLC Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    pattern="(?!.*(?:[ ][cC][oO][rR][pP]$))(?!.*(?:[ ][iI][nN][cC]$))^[ a-zA-Z0-9\\&-]+$"
                    maxLength="70"
                    onChange={(e) => setLLCName2(e.target.value)}
                    defaultValue={
                      product.alternateLegalNames && product.alternateLegalNames[0]
                        ? product.alternateLegalNames[0]
                        : ""
                    }
                  />
                  <Form.Control.Feedback type="invalid">Please provide a valid organization name</Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="llcName3">
                  <Form.Label>Alternate LLC Name 2</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    pattern="(?!.*(?:[ ][cC][oO][rR][pP]$))(?!.*(?:[ ][iI][nN][cC]$))^[ a-zA-Z0-9\\&-]+$"
                    maxLength="70"
                    onChange={(e) => setLLCName3(e.target.value)}
                    defaultValue={
                      product.alternateLegalNames && product.alternateLegalNames[1]
                        ? product.alternateLegalNames[1]
                        : ""
                    }
                  />
                  <Form.Control.Feedback type="invalid">Please provide a valid organization name</Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="header">
                  <Form.Label className="mb-5 file">
                    To aid with this, you may also attach your Articles of Incorporation below:
                  </Form.Label>
                </Form.Group>
                <Form.File id="formcheck-api-regular" style={{ padding: "0 20px 0 20px" }}>
                  <Form.File.Input onChange={(e) => setSelectedFile(e.target.files[0])} />
                </Form.File>
                <div className="invalid-feedback d-block mt-0 mb-2">{dError}</div>
                <Button variant="primary" type="submit" className="mt-4">
                  Update info
                </Button>
              </Form>
            </Container>
          </>
        ) : null}
        {props.order.processingStatus === "Error" &&
        product &&
        props.order.processingError === "Error101NameConflict" &&
        product.code.code !== "EIN_LLC" ? (
          <>
            <Container fluid className="Form contact">
              <Form>
                <Form.Group controlId="header">
                  <Form.Label className="mb-5" style={{ textAlign: "justify" }}>
                    Our specialists have identified an issue with your submission that prevents us from completing the
                    order without additional verification. Please reference the verification section below, or check
                    your e-mail for a follow-up request from us. Please note this is Urgent and we will not be able to
                    proceed until we hear from you.
                  </Form.Label>
                </Form.Group>
              </Form>
            </Container>
          </>
        ) : null}
      </div>
    </div>
  );
}
